angular.module('eStories.google.model', [
    /*eStories Google Module*/
]).service('GoogleModel', ['AccountModel', function (AccountModel) {
    var model = this;
    model.trackConversion = function (label, value, currency) {
        // handle the case of popup blockers that don't let us load the conversion_async js
        if (typeof window.google_trackConversion == 'undefined') {
            return;
        }
        
        console.log("Tracking conversion. l: " + label + " v: " + value + ", c: " + currency);
        window.google_trackConversion({
            google_conversion_id: 925634046,
            google_conversion_language: "en",
            google_conversion_format: "3",
            google_conversion_color: "ffffff",
            google_conversion_label: label,
            google_conversion_value: value,
            google_conversion_currency: currency,
            google_remarketing_only: false
        });
    }

    model.dynamicRemarketing = function (pageType, audiobook) {
        // handle the case of popup blockers that don't let us load the conversion_async js
        if (typeof window.google_trackConversion == 'undefined') {
            return;
        }
        
        if (audiobook != null && audiobook.title != null && audiobook.id != null) {
            console.log("Dynamic remarketing. title: " + audiobook.title + " id: " + audiobook.id + " pagetype: " + pageType);
        } else {
            console.log("Dynamic remarketing. pagetype: " + pageType);
        }

        // pageType indicates the type of page that the tag is on. Valid values:
// Used:
        // offerdetail Used on pages that show details of a particular product.
// Not used:        
        // home Used on the home page or landing page of your site.
        // searchresults Used on pages where the results of a user's search are displayed.
        // conversionintent Used on the cart/basket/checkout page.
        // conversion Used on the page shown once a user has purchased (and so converted), for example a "Thank You" or confirmation page.
        // cancel Used on pages where a user has canceled their booking.
        // other Used where the page does not fit into the other types of page, for example a "Contact Us" or "About Us" page.

        var googleTagParams = {
            dynx_pagetype: pageType
        };
        
        if (audiobook != null) {
            if (audiobook.length != null ) {
                var idList = [];
                for (var i; i < audiobook.length ; i ++ ) {
                    idList[i] = audiobook[i].id.toString();
                }
            } else if (audiobook.id != null) {
                googleTagParams.dynx_itemid = audiobook.id.toString();
            }
        }

        if (pageType == "conversionintent") {
            googleTagParams.dynx_totalvalue = AccountModel.getAudiobookPrice(audiobook, false, false);
        }

        // window.google_tag_params = googleTagParams ;
        window.google_trackConversion({
            google_conversion_id: 925634046,
            google_custom_params: googleTagParams,
            google_remarketing_only: true
        });
    }
}]);

